import ClientActions from '../actions/ClientActions'
import StorePrototype from '../../../shared_components/StorePrototype'

const ClientStore = StorePrototype(ClientActions.Types.GOT_CLIENT)

export default ClientStore
